<template>
  <BasicLayout>
    <template #wrapper>
      <UserGroup class="mtop" />

      <UserGroupStat class="mtop" />
      <FinishtutorialData class="mtop" />
      <UserSpin class="mtop" />

      <el-card class="box-card" style="margin-top: 10px">
        <div slot="header" class="clearfix">
          <span>用户消耗</span>
        </div>

        <el-form ref="queryForm5" :model="queryParams5" :inline="true">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams5.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery5"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams5.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery5"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery5">查询</el-button>
            <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="exportData(6)">导出</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="tableStatData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
            width="100px"
          />
          <el-table-column
            prop="obtain_spin"
            label="获得体力"
            align="center"
            :formatter="numFormatter2"
          />

          <el-table-column
            prop="cost_spin"
            label="消耗体力"
            align="center"
            :formatter="numFormatter2"
          />

          <el-table-column
            prop="obtain_coin"
            label="获得金币"
            align="center"
            :formatter="numFormatter2"
          />

          <el-table-column
            prop="cost_coin"
            label="消耗金币"
            align="center"
            :formatter="numFormatter2"
          />

          <el-table-column
            prop="obtain_card"
            label="获取卡片数量"
            align="center"
            :formatter="numFormatter2"
          />

          <el-table-column
            prop="cost_card"
            label="消耗卡片数量"
            align="center"
            :formatter="numFormatter2"
          />

          <el-table-column
            prop="spin_times"
            label="转动次数"
            align="center"
            :formatter="numFormatter2"
          />

          <el-table-column
            prop="stock_coin"
            label="金币存量"
            align="center"
            :formatter="numFormatter2"
          />
          <el-table-column
            prop="stock_spin"
            label="体力存量"
            align="center"
            :formatter="numFormatter2"
          />

        </el-table>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户等级</span>
        </div>

        <el-form ref="queryForm3" :model="queryParams3" :inline="true">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams3.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery3"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams3.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery3"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery3">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
          </el-form-item>
        </el-form>

        <el-table
          :data="tableLevelData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
            width="100px"
            align="center"
          />

          <el-table-column
            v-for="(item, index) in levelTitle2"
            :key="index"
            prop="date"
            :label="index"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.level_data[index] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <UserConsume />

      <UserBet />

      <el-card id="userAvg" class="box-card" style="margin-top: 10px">
        <div slot="header" class="clearfix">
          <span>人均数值</span>
        </div>
        <IndexUserDataAvg />
      </el-card>

      <el-card class="box-card" style="margin-top: 10px">
        <div slot="header" class="clearfix">
          <span>棋盘格子触发统计</span>
        </div>
        <ChessBoardRate />
      </el-card>

      <el-card class="box-card" style="margin-top: 10px">
        <div slot="header" class="clearfix">
          <span>用户签到人数统计</span>
        </div>
        <user-sign />
      </el-card>

      <el-card class="box-card" style="margin-top: 10px">
        <div slot="header" class="clearfix">
          <span>用户付费渗透率</span>
        </div>
        <UserPayPermeability />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  getUserVersionStat,
  exportStatData, getUserLevelStat2, getUserStat
} from '@/api/statistics/user_remain'
import echarts from 'echarts'
import UserConsume from '@/views/config/user-spins/comments/user-consume.vue'
import UserSpin from '@/views/config/user-spins/comments/user-spin.vue'
import UserBet from '@/views/config/user-spins/comments/user-bet.vue'
import { scientificFormat, scrollToAnchor } from '@/utils'
import ChessBoardRate from '@/views/config/user-spins/comments/chess-board-rate.vue'
import IndexUserDataAvg from '@/components/Index/IndexUserDataAvg.vue'
import UserGroup from '@/views/config/user-spins/comments/user-group.vue'
import UserGroupStat from '@/views/config/user-spins/comments/user-group-stat.vue'
import FinishtutorialData from '@/views/config/user-spins/comments/finishtutorial.vue'
import UserPayPermeability from '@/views/config/user-spins/comments/user-pay-permeability.vue'
import UserSign from '@/views/config/user-spins/comments/user-sign.vue'
export default {
  name: 'UserSpins',
  components: {
    UserSign,
    UserPayPermeability,
    UserGroup,
    IndexUserDataAvg,
    // IndexVersion,
    UserConsume,
    UserSpin,
    UserBet,
    ChessBoardRate,
    UserGroupStat,
    FinishtutorialData
    // IndexUserOnlineAvg
  },
  data() {
    return {
      total: 0,
      coinTotal: 0,
      levelTotal: 0,
      levelTitle: [],
      tableStatData: [],
      levelTitle2: {},
      queryParams2: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        level: -1
      },
      queryParams3: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      },
      queryParams4: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      },
      queryParams5: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      },
      loading: false,
      tableData: [],
      tableCoinData: [],
      tableLevelData: [],
      levelData: []
    }
  },
  created() {
    // this.getTables()
    this.getUserLevelData()
    this.getUserVersionData()
    this.getUserStatData()
  },
  mounted() {
    scrollToAnchor()

    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.handleQuery()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.resetForm('queryForm2')
      this.resetForm('queryForm3')
      this.resetForm('queryForm4')
      this.handleQuery()
      this.handleQuery2()
      this.handleQuery3()
      this.handleQuery4()
    },
    handleQuery3() {
      if (this.queryParams3.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams3.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams3.startDate > this.queryParams3.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getUserLevelData()
    },
    handleQuery5() {
      if (this.queryParams5.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams5.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams5.startDate > this.queryParams5.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getUserStatData()
    },
    handleQuery4() {
      if (this.queryParams4.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      this.getUserVersionData()
    },
    getUserStatData() {
      getUserStat(this.queryParams5).then(res => {
        if (res.code === 200) {
          this.tableStatData = res.data.data
          this.queryParams5.startDate = res.data.req.startDate
          this.queryParams5.endDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getUserLevelData() {
      this.loading = true
      getUserLevelStat2(this.queryParams3).then(res => {
        this.loading = false
        if (res.code === 200) {
          const tableLevelData = res.data.data
          const list = res.data.list
          const maxLevel = res.data.maxLevel
          for (let i = 1; i <= maxLevel; i++) {
            this.levelTitle2[i] = i
          }

          for (const i in tableLevelData) {
            const val = tableLevelData[i]
            for (const k in list) {
              const data = list[k]
              if (val.date === data.date) {
                val.level_data[data.levelId] = data.count
              }
            }
            tableLevelData[i] = val
          }
          this.tableLevelData = tableLevelData
          this.queryParams3.startDate = res.data.req.startDate
          this.queryParams3.endDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getUserVersionData() {
      getUserVersionStat(this.queryParams4).then(res => {
        if (res.code === 200) {
          this.queryParams4.startDate = res.data.req.startDate
          this.queryParams4.endDate = res.data.req.endDate
          this.option.xAxis.data = []
          this.option.series = []
          const versionArr = {}
          const versionCount = {}
          const dateData = {}
          const dateArr = {}
          for (const i in res.data.data) {
            const val = res.data.data[i]
            if (val.version === 'undefined') {
              continue
            }
            versionArr[val.version] = val.version
            versionCount[val.version] = 0
            dateArr[val.date] = []
          }
          this.option.legend.data = []
          for (const i in dateArr) {
            const v = Object.assign({}, versionCount)
            dateData[i] = v
            this.option.xAxis.data.push(i)
          }

          for (const i in res.data.data) {
            const data = res.data.data[i]
            for (const k in dateData) {
              if (k === data.date) {
                const val = dateData[k]
                for (const v in val) {
                  if (v === data.version) {
                    val[v] = data.count
                  }
                }
                dateData[k] = val
              }
            }
          }
          this.option.series = []
          for (const i in versionArr) {
            const series = {
              name: '',
              data: [],
              type: 'line',
              smooth: true,
              label: {
                show: true,
                position: 'top', // 标签显示在折线图顶部
                formatter: '{c}' // 显示数值
              }
            }
            this.option.legend.data.push(i)
            series.name = i
            for (const k in dateData) {
              const val = dateData[k]
              for (const v in val) {
                if (series.name === v) {
                  // console.log(series1.name, v, val[v])
                  series.data.push(val[v])
                }
              }
            }
            // console.log('series1', series1)
            this.option.series.push(series)
          }
          this.chart.setOption(this.option)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '用户版本'
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
      this.chart.setOption(this.option)
    },
    exportData(typ) {
      let start = ''
      let end = ''
      switch (typ) {
        case 2:
          this.handleQuery(false)
          start = this.queryParams.startDate
          end = this.queryParams.endDate
          break

        case 6:
          this.handleQuery5(false)
          start = this.queryParams5.startDate
          end = this.queryParams5.endDate
          break
      }

      if (start === '' || end === '') {
        return
      }
      exportStatData({ startDate: start, endDate: end, type: typ }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter2(col, row, val) {
      return scientificFormat(val)
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 10px;
}
</style>
